import ApiService from '@/common/api.service'

export default {
  getDocumentList (ankenId) {
    return new Promise((resolve, reject) => {
      ApiService.post('/document/memberList', ankenId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteFile (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/document/deleteFile', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  uploadFile (payload) {
    return new Promise((resolve, reject) => {
      ApiService.post('/document/upload', payload).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
